module.exports = __webpack_public_path__ + "img/wximg5.432bf642.png";